import { createContext } from 'react';

interface FeatureToggleContextValue {
  isFeatureEnabled: (featureName: string) => boolean;
}

const FeatureToggleContext = createContext<FeatureToggleContextValue>({
  isFeatureEnabled: () => false,
});

export default FeatureToggleContext;
